import { TenantFrontendRoute } from './tenant-frontend-routing';

export const DEV_TENANT_ROUTES: readonly TenantFrontendRoute[] = [
  {
    tenantId: 'heron',
    advisorFrontendUrl: 'https://everglades-dev.projects.sprint-in.com',
    clientFrontendUrl: 'https://everglades-client-dev.projects.sprint-in.com',
    apiOrigin: 'https://everglades-dev-api.projects.sprint-in.com',
    brandId: 'heron'
  },
  {
    tenantId: 'mab',
    advisorFrontendUrl: 'https://tenant-1-advisor.everglades-dev.sprint-in.com',
    clientFrontendUrl: 'https://tenant-1.everglades-dev.sprint-in.com',
    apiOrigin: 'https://tenant-1.everglades-api-dev.sprint-in.com',
    brandId: 'mab'
  },
  {
    tenantId: 'citrus',
    advisorFrontendUrl: 'https://tenant-2-advisor.everglades-dev.sprint-in.com',
    clientFrontendUrl: 'https://tenant-2.everglades-dev.sprint-in.com',
    apiOrigin: 'https://tenant-2.everglades-api-dev.sprint-in.com',
    brandId: 'citrus'
  },
  {
    tenantId: null,
    advisorFrontendUrl: 'https://tenant-3-advisor.everglades-dev.sprint-in.com',
    clientFrontendUrl: 'https://tenant-3.everglades-dev.sprint-in.com',
    apiOrigin: 'https://tenant-3.everglades-api-dev.sprint-in.com',
    brandId: null
  },
  {
    tenantId: 'heron',
    advisorFrontendUrl: 'http://localhost:4200',
    clientFrontendUrl: 'http://localhost:4300',
    apiOrigin: 'https://everglades-dev-api.projects.sprint-in.com',
    brandId: 'heron'
  }
];
